export default __webpack_public_path__ + "static/media/material-waste.ec387ec6.svg";